import angular from 'angular';

angular
  .module('cloudX')
  .controller('YesNoListDialogCtrl', [
    '$scope',
    'appMessages',
    'close',
    'title',
    'message',
    'items',
    yesNoListDialogCtrl,
  ]);

function yesNoListDialogCtrl($scope, appMessages, close, title, message, items) {
  $scope.title = appMessages(title);
  $scope.message = appMessages(message);
  $scope.items = items;
  $scope.close = function(result) {
    close(result, 500);
  };
}
